export default __webpack_public_path__ + "static/media/feature3-1.ad74f99e.png";